import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { equipmentGroupListRequest, getEquipmentGroupList, getManualLoadForLeaderBoard, getSourceEgKPIData, getAutomaticEgLoad, setLeaderBoardSelectedWorkType } from "../../../actions/dashboard";
import { getEGReportIssue } from "../../../actions/equipment-group";
import { isElasticLoad } from "../../../helpers/common";
import { getDateRangeInfo } from "../../../actions/analyze";
import { AvatarWithDropdownSelection } from "../utils";
import { WORK_TYPE_COLOURS, PLAN_TYPE_LIST, HARVEST_WORK_TYPE_IDS, CART_CATEGORYIDS } from "../../../constants";

const Header = () => {
  const dispatch = useDispatch();
  const farmId = useSelector((state) => state.dashboard.farmId);
  const planPlannedToDate = useSelector((state) => (farmId && state.analyze.searchParams.plannedTodate[farmId] ? state.analyze.searchParams.plannedTodate[farmId] : null));
  const workTypeList = useSelector((state) => state.dashboard.workTypeList.payload);
  const activeWorkType = useSelector((state) => state.dashboard.leaderBoard.selectedWorkTypeIds);
  const isRequestingPlanPlannedToDate = planPlannedToDate ? planPlannedToDate.isRequesting : false;
  const refreshCount = useSelector((state) => state.dashboard.refreshCount);
  const egList = useSelector((state) => state.dashboard.leaderBoard.egList.payload);
  const { rangeId, range, custom } = useSelector((state) => state.analyze.searchParams);
  const selectedPlanType = useSelector((state) => state.plan.selectedPlanType);
  const isAllPlan = useSelector((state) => state.plan.isSelectAllPlan);
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    if (!farmId) return;
    const cb = (dateInfo) => getEgList(dateInfo);

    if (isRequestingPlanPlannedToDate) dispatch(equipmentGroupListRequest(isRequestingPlanPlannedToDate));
    dispatch(getDateRangeInfo({ farmId }, cb));
  }, [farmId, rangeId, isRequestingPlanPlannedToDate, selectedPlanType]);

  useEffect(() => {
    if (isRendered) getEgInfo(egList);
    setIsRendered(true);
  }, [refreshCount]);

  useEffect(() => {
    const params = { fromDate: custom.from, toDate: custom.to, range };
    getEgList(params);
  }, [selectedPlanType, isAllPlan]);

  useEffect(() => {
    if(egList && egList.length > 0) {
      getEgInfo(egList);
    }
  }, [activeWorkType]);

  const getEgList = (dateInfo) => {
    if (farmId) {
      const selectedPlanTypeForLeaderboard = isAllPlan ? null : selectedPlanType;
      const reqData = { farmId, ...dateInfo, selectedPlanType: selectedPlanTypeForLeaderboard };
      dispatch(getEquipmentGroupList(reqData, getEgInfo));
      dispatch(getEGReportIssue(farmId));
    }
  };

  const getEgInfo = (egList, planTypeId) => {
    if (!farmId) return;
    const selectedPlan = PLAN_TYPE_LIST.filter((plan) => {
      if (plan.workTypes.includes(planTypeId ? planTypeId : activeWorkType[0]) && plan.plan_type_id !== 10) {
        return true;
      } else return false;
    }).map((e) => e.plan_type_id);

    const selectedPlanTypeForLeaderboard = isAllPlan ? selectedPlan[0] : selectedPlanType;

    const cb = (dateInfo) => {
      const params = { farmId: farmId, planTypeId: selectedPlanTypeForLeaderboard, ...dateInfo };

      if (isElasticLoad()) {
        dispatch(getAutomaticEgLoad({ ...params, egIds: egList.map((e) => e.equipment_group_uuid) }));
      } else {
        dispatch(getManualLoadForLeaderBoard("source", params));
        dispatch(getManualLoadForLeaderBoard("target", params));
      }

      const egLists = [...egList.filter((e) => !e.vehicle.is_truck), ...egList.filter((e) => CART_CATEGORYIDS.includes(e.primary_category_id))];
      const egIds = egLists.map((e) => e.equipment_group_uuid);
      dispatch(getSourceEgKPIData({ ...params, egIds }));
    };

    dispatch(getDateRangeInfo({ farmId }, cb));
  };

  const handleWorkType = (item) => {
    let list = [];

    if (HARVEST_WORK_TYPE_IDS.indexOf(item) > -1) {
      list = activeWorkType.filter((e) => HARVEST_WORK_TYPE_IDS.includes(e));
    }

    if (list.indexOf(item) >= 0) {
      if (list.length >= 2) list.splice(list.indexOf(item), 1);
    } else list.push(item);

    getEgInfo(egList, item);
    dispatch(setLeaderBoardSelectedWorkType(list));
  };

  let egListWorkType = [];
  egList.forEach((item) => {
    if (egListWorkType.indexOf(item.work_type_id) >= 0) return;
    else egListWorkType.push(item.work_type_id);
  });

  return (
    <Row className="header">
      <Col className="title"> Leader Boards </Col>
      {isAllPlan && (
        <Col className="p-0 pr-1">
          <div className="avatar-input">
            <AvatarWithDropdownSelection list={workTypeList} activeType={egListWorkType} selectedList={activeWorkType} color={WORK_TYPE_COLOURS} idKeyValue="work_type_id" nameKeyValue="work_type" handleSelect={handleWorkType} />
          </div>
        </Col>
      )}
    </Row>
  );
};

export default Header;
